import * as React from 'react';
import { memo } from 'react';

import Bevel from 'components/helper/Bevel';

import Coach from 'components/atoms/Coach';
import { LinkProps } from 'components/atoms/Link';
import { CoachIsEnumType } from 'components/molecules/CoachSelector';
import LinkList from 'components/molecules/LinkList';

export type TextBoxProps = {
	title?: string;
	text?: string;
	coach?: CoachIsEnumType;
	buttons?: LinkProps[];
	modifier?: string;
	bevel?: string;
	gesture?: string;
};

export const TextBox = ({
	title,
	text,
	buttons,
	coach,
	gesture = 'front-top',
	modifier = '',
	bevel = '',
}: TextBoxProps) => {
	return (
		<div className={`m-text-box${modifier ? ` m-text-box--${modifier}` : ''}`}>
			<div className="container container--full-width-ms">
				<div className="row">
					<div className="col-xs-12">
						<div className="m-text-box__content">
							{coach && (
								<div className="m-text-box__coach-box">
									<div className="m-text-box__coach-wrap">
										<Coach coach={coach} gesture={gesture} alt={coach} />
									</div>
								</div>
							)}
							<div className="m-text-box__message">
								{title && <h2 className="m-text-box__title">{title}</h2>}
								{text && <p className="m-text-box__text">{text}</p>}
							</div>
							{buttons && (
								<div className="m-text-box__links">
									<LinkList links={buttons} />
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
			{bevel ? (
				<div className="m-text-box__bevel">
					<Bevel modifier={bevel} color="0099A6" />
				</div>
			) : null}
		</div>
	);
};

TextBox.displayName = 'TextBox';

export default memo(TextBox);
